import React, { useState, useEffect } from 'react';
import { Tag, Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import { fetchReviews, removeReview } from '../../actions/ReviewAction';
import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

const Reviews = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();

  const currentProject = useSelector(({ project }) => project.currentProject);
  const reviews = useSelector(({ review }) => review.reviews);

  const openDetail = (orderId) => {
    history.push(`/ecommerce/reviews/${orderId}`);
  };

  const columns = [
    {
      dataIndex: 'link',
      key: 'link',
      render: (link) => (
        <Image
          height={40}
          src={link}
          style={{ borderRadius: '50%', objectFit: 'cover' }}
          width={40}
        />
      ),
      title: () => {
        return <div style={{ textAlign: 'center' }}>Preview</div>;
      }
    },
    {
      dataIndex: 'id',
      key: 'id',
      render: (id) => {
        return <Copy text={id} />;
      },
      sorter: (a, b) => a.id.localeCompare(b.id),
      title: 'Review ID'
    },
    {
      dataIndex: 'buyer',
      key: 'buyer',
      render: (buyer) => {
        return <Copy text={buyer} />;
      },
      sorter: (a, b) => a.buyer.localeCompare(b.buyer),
      title: 'Buyer'
    },
    {
      dataIndex: 'seller',
      key: 'seller',
      render: (seller) => {
        return <Copy text={seller} />;
      },
      sorter: (a, b) => a.seller.localeCompare(b.seller),
      title: 'Seller'
    },
    {
      dataIndex: 'orderId',
      key: 'orderId',
      render: (orderId) => {
        return <Copy text={orderId} />;
      },
      sorter: (a, b) => a.orderId.localeCompare(b.orderId),
      title: 'Order ID'
    },
    {
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt) => {
        return <Copy text={createdAt} />;
      },
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      title: 'Created At'
    },
    {
      key: 'edit',
      render: (review) => {
        return <Tag onClick={() => openDetail(review.orderId)}>View</Tag>;
      }
    }
  ];

  const mapToTable = (reviews) => {
    const data = [];

    if (!reviews || !reviews.length) {
      return data;
    }

    reviews.forEach(
      ({ _id, profile, title, orderId, user, createdAt, category, options }, index) => {
        data.push({
          buyer: `@${profile.userName}`,
          category,
          createdAt: formatDate(createdAt),
          id: _id,
          key: index,
          link: profile.profilePictureUrl,
          orderId,
          seller: user,
          status: options?.length ? 'For Sale' : 'Sold',
          title
        });
      }
    );

    return data;
  };

  const onDownload = () => {};

  const onReviewDelete = () => {
    // eslint-disable-next-line no-restricted-syntax
    for (const index of selectedRowKeys) {
      const item = data[index];

      dispatch(
        removeReview(currentProject._id, item.orderId, () => {
          dispatch(fetchReviews());
        })
      );
    }

    setSelectedRowKeys([]);
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchReviews());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  const data = mapToTable(reviews);

  const actions = [
    {
      disabled: false,
      onClick: onDownload,
      title: 'Download CSV',
      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: onReviewDelete,
      title: 'Delete',
      type: 'secondary'
    });
  }

  const isLoaded = useSelector(({ review }) => review.isLoaded);

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={reviews.length} title="Reviews" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        loading={!isLoaded}
        searchBy="buyer"
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default Reviews;
